import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { EnvironmentService } from './core/environment/environment.service';
import { AuthenticationService } from './_services/authentication/authentication.service';

declare var appInsights;

@Component({
    selector: 'pipe-workplace',
    template: `<router-outlet moduleInitializer></router-outlet>`
})
export class WorkplaceComponent implements OnInit {
    constructor(environment: EnvironmentService, title: Title, private router: Router, private auth: AuthenticationService) {

	    title.setTitle("Pipe Workplace" + (environment.currentEnvironment ? " - " + environment.currentEnvironment : ""));

        if (window['appInsights']) {
            router.events.subscribe((event: NavigationEnd) => {
                if(event instanceof NavigationEnd) {
                    appInsights.trackPageView();
                }
            })
        }
    }

  

    ngOnInit() {
        if (document.location.pathname === "/" || document.location.pathname === "") {
            this.goToDashboard();
        }
	}

    onUserLoggedIn() {
        this.goToDashboard();
    }

    private goToDashboard() {
        window.setTimeout(() => {
            this.router.navigateByUrl('/dashboard');
        })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/workplace.component.ts